
export const photos = [
  {
    eventId: 'event1',
    eventName: 'Annual Function 2024',
    images: [
      { url: 'https://imgs.search.brave.com/NHB3Dhy_Dh4Nwiy6yjhQJLIxwvGsWzN4-tL_t_sIXgc/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pbWcu/ZnJlZXBpay5jb20v/ZnJlZS1waG90by9j/YWxjdWxhdG9yLXBh/cGVyc18yMy0yMTQ4/MTQ4MzAzLmpwZz9z/aXplPTYyNiZleHQ9/anBn', alt: 'Image 1' },
      { url: 'https://imgs.search.brave.com/5XQhECbNTPtd4RkW2X2o6SG3-aGEWgSTfMPPpNBWBNY/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly90My5m/dGNkbi5uZXQvanBn/LzA0LzY1LzQ1Lzc2/LzM2MF9GXzQ2NTQ1/NzY3OV9SMm9Ianht/ejEwQ3BISEM1Zkli/MGpiWTNhWFlNOHdr/aS5qcGc', alt: 'Image 2' },
      { url: 'image3.jpg', alt: 'Image 3' },
      // Add more images if needed
    ]
  },
  {
    eventId: 'event2',
    eventName: `Children's Day 2023`,
    images: [
      { url: 'https://imgs.search.brave.com/NHB3Dhy_Dh4Nwiy6yjhQJLIxwvGsWzN4-tL_t_sIXgc/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pbWcu/ZnJlZXBpay5jb20v/ZnJlZS1waG90by9j/YWxjdWxhdG9yLXBh/cGVyc18yMy0yMTQ4/MTQ4MzAzLmpwZz9z/aXplPTYyNiZleHQ9/anBn', alt: 'Image 4' },
      { url: 'https://imgs.search.brave.com/5XQhECbNTPtd4RkW2X2o6SG3-aGEWgSTfMPPpNBWBNY/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly90My5m/dGNkbi5uZXQvanBn/LzA0LzY1LzQ1Lzc2/LzM2MF9GXzQ2NTQ1/NzY3OV9SMm9Ianht/ejEwQ3BISEM1Zkli/MGpiWTNhWFlNOHdr/aS5qcGc', alt: 'Image 5' },
      // Add more images if needed
    ]
  },
  {
    eventId: 'event3',
    eventName: `Diwali Celebration 2023`,
    images: [
      { url: 'https://imgs.search.brave.com/NHB3Dhy_Dh4Nwiy6yjhQJLIxwvGsWzN4-tL_t_sIXgc/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pbWcu/ZnJlZXBpay5jb20v/ZnJlZS1waG90by9j/YWxjdWxhdG9yLXBh/cGVyc18yMy0yMTQ4/MTQ4MzAzLmpwZz9z/aXplPTYyNiZleHQ9/anBn', alt: 'Image 4' },
      { url: 'https://imgs.search.brave.com/5XQhECbNTPtd4RkW2X2o6SG3-aGEWgSTfMPPpNBWBNY/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly90My5m/dGNkbi5uZXQvanBn/LzA0LzY1LzQ1Lzc2/LzM2MF9GXzQ2NTQ1/NzY3OV9SMm9Ianht/ejEwQ3BISEM1Zkli/MGpiWTNhWFlNOHdr/aS5qcGc', alt: 'Image 5' },
      // Add more images if needed
    ]
  },
  {
    eventId: 'event4',
    eventName: `Independence Day 2023`,
    images: [
      { url: 'https://imgs.search.brave.com/NHB3Dhy_Dh4Nwiy6yjhQJLIxwvGsWzN4-tL_t_sIXgc/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pbWcu/ZnJlZXBpay5jb20v/ZnJlZS1waG90by9j/YWxjdWxhdG9yLXBh/cGVyc18yMy0yMTQ4/MTQ4MzAzLmpwZz9z/aXplPTYyNiZleHQ9/anBn', alt: 'Image 4' },
      { url: 'https://imgs.search.brave.com/5XQhECbNTPtd4RkW2X2o6SG3-aGEWgSTfMPPpNBWBNY/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly90My5m/dGNkbi5uZXQvanBn/LzA0LzY1LzQ1Lzc2/LzM2MF9GXzQ2NTQ1/NzY3OV9SMm9Ianht/ejEwQ3BISEM1Zkli/MGpiWTNhWFlNOHdr/aS5qcGc', alt: 'Image 5' },
      // Add more images if needed
    ]
  }
  // Add more events if needed
];
